import apiClient from './apiClient';

export type SyncConflictStatus = 'open' | 'resolved' | 'discarded';

export interface SyncConflictReviewItem {
  id: string;
  entityType: string;
  entityId: string;
  clientUuid?: string | null;
  projectId?: string | null;
  baseVersionAt?: string | null;
  serverVersionAt?: string | null;
  clientPayload: Record<string, any>;
  serverPayload: Record<string, any> | null;
  status: SyncConflictStatus;
  createdAt?: string;
}

const unwrap = <T>(response: any): T => response?.data ?? response;

class SyncService {
  async listConflicts(params: { projectId?: string; status?: SyncConflictStatus } = {}): Promise<SyncConflictReviewItem[]> {
    return unwrap<SyncConflictReviewItem[]>(await apiClient.get('/sync/conflicts', { params }));
  }

  async resolveConflict(id: string, notes?: string): Promise<SyncConflictReviewItem> {
    return unwrap<SyncConflictReviewItem>(await apiClient.post(`/sync/conflicts/${id}/resolve`, { notes: notes ?? null }));
  }

  async discardConflict(id: string, notes?: string): Promise<SyncConflictReviewItem> {
    return unwrap<SyncConflictReviewItem>(await apiClient.post(`/sync/conflicts/${id}/discard`, { notes: notes ?? null }));
  }
}

export default new SyncService();
